import { render, staticRenderFns } from "./AvatarGoal.vue?vue&type=template&id=598b7eb4&"
import script from "./AvatarGoal.vue?vue&type=script&lang=ts&"
export * from "./AvatarGoal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports